export const CONTACT_SALES_CONSTANTS = {
	QUALIFICATION_CRITERIA: {
		SMALL_LEAD: {
			DAILY_CALLS: '1-10',
			COMPANY_SIZES: ['1 - 5', '5 - 15'],
		},
		BIG_LEAD: {
			DAILY_CALLS: ['11-25', '26-50', '51-100', '100+'],
			COMPANY_SIZES: ['16 - 50', '50 - 200', '200 - 500', '500+'],
		},
	},

	CALENDLY_URLS: {
		QUALIFIED: 'https://calendly.com/d/cv4k-mv3-6pc/frontdesk-ai-receptionist-discovery',
		SMALL_LEAD: 'https://calendly.com/d/cmq2-bzn-bth/ai-front-desk-onboarding-setup-help',
	},

	STORAGE_KEYS: {
		SUBMITTED: 'contactSalesSubmitted',
		SHOW_CALENDLY: 'contactSalesShowCalendly',
	},

	SERVICE_PROVIDER: 'service_provider',
} as const;

export const ROLES = [
	{
		value: 'business_owner',
		label: 'I’m a business owner or manager',
	},
	{
		value: 'service_provider',
		label: 'I provide services to business owners',
	},
];

export const WHITELABEL_URL = 'https://www.myaifrontdesk.com/white-label';
